import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DashboardService, DashboardStats } from '../../services/dashboard.service';
import { Observable } from 'rxjs';
import { User } from '@angular/fire/auth';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, HttpClientModule, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  user$!: Observable<User | null>;
  dashboardStats: DashboardStats | null = null;
  isLoadingStats = true;
  statsError: string | null = null;

  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService
  ) {
    this.user$ = this.authService.user$;
  }

  ngOnInit(): void {
    console.log('🎯 Dashboard component initialized');
    this.loadDashboardStats();
  }


  loadDashboardStats(): void {
    this.isLoadingStats = true;
    this.statsError = null;

    this.dashboardService.getDashboardStats().subscribe({
      next: (stats) => {
        this.dashboardStats = stats;
        this.isLoadingStats = false;
      },
      error: (error) => {
        console.error('Error loading dashboard stats:', error);
        this.statsError = 'Failed to load dashboard stats';
        this.isLoadingStats = false;
      }
    });
  }

  async onSignOut(): Promise<void> {
    try {
      await this.authService.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }
}